import { Reveal, PrimaryButton, Eyebrow } from "./primitives";

// Closing "Book a Strategy Call" band. Variant: dark (default) or taupe.
export default function CTABand({
  eyebrow = "Let's Begin",
  title = "Ready to build a brand that lasts?",
  variant = "dark",
}) {
  const dark = variant === "dark";
  return (
    <section
      data-testid="cta-band"
      className={`${dark ? "bg-night text-ivory" : "bg-taupe text-charcoal"}`}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-20 py-24 md:py-36 text-center">
        <Reveal>
          <Eyebrow>{eyebrow}</Eyebrow>
          <h2 className={`mt-6 font-serif font-light leading-[1.05] tracking-tight text-4xl md:text-6xl lg:text-7xl max-w-4xl mx-auto ${dark ? "text-ivory" : "text-charcoal"}`}>
            {title}
          </h2>
          <div className="mt-10 flex justify-center">
            <PrimaryButton light={dark} testId="cta-band-book-call" />
          </div>
        </Reveal>
      </div>
    </section>
  );
}
